import React, { useCallback, useEffect, useState } from "react";
import { useNetworkStatus } from "../../../../context/NetworkContext";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import WifiIcon from "@mui/icons-material/Wifi";
import "./NetworkStatusPopup.css";

const NetworkStatusPopup = ({ onReload }) => {
  const { isOnline } = useNetworkStatus();
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [hasBeenOffline, setHasBeenOffline] = useState(false);
  const [mobileTriggered, setMobileTriggered] = useState(false);

  const handleReload = useCallback(() => {
    setShowPopup(false);
    setMobileTriggered(false); // Reset mobile trigger
    if (onReload) {
      onReload();
    }
  }, [onReload]);

  useEffect(() => {
    if (!isOnline) {
      // User went offline
      setShowPopup(true);
      setPopupType("offline");
      setHasBeenOffline(true);
    } else if (isOnline && hasBeenOffline && !mobileTriggered) {
      // User came back online after being offline (but not mobile triggered)
      setShowPopup(false);
      // setPopupType("online");
      setHasBeenOffline(false);
      handleReload();
    }
  }, [isOnline, hasBeenOffline, mobileTriggered, handleReload]);

  // Listen for mobile network reload triggers
  useEffect(() => {
    const handleMobileNetworkReload = (event) => {
      console.log("Mobile network reload triggered:", event.detail);
      setMobileTriggered(true);
      setHasBeenOffline(false);

      // Auto-reload immediately for mobile triggers instead of showing popup
      if (event.detail?.autoReload !== false) {
        console.log("Auto-reloading for mobile trigger");
        handleReload();
      } else {
        // Fallback: show popup if autoReload is explicitly disabled
        setShowPopup(true);
        setPopupType("online");
      }
    };

    window.addEventListener("mobileNetworkReload", handleMobileNetworkReload);

    return () => {
      window.removeEventListener(
        "mobileNetworkReload",
        handleMobileNetworkReload
      );
    };
  }, [handleReload]);

  if (!showPopup) return null;

  return (
    <div
      className={`network-status-popup ${popupType} ${showPopup ? "show" : ""}`}
    >
      <div className="network-status-content">
        {popupType === "offline" ? (
          <>
            <div className="network-icon offline">
              <WifiOffIcon />
            </div>
            <div className="network-text">
              <div className="network-title">Looks like you're offline</div>
              <div className="network-subtitle">
                Check your internet connection
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="network-icon online">
              <WifiIcon />
            </div>
            <div className="network-text">
              <div className="network-title">You're back online!</div>
              <div className="network-subtitle">
                Reload to get latest messages
              </div>
            </div>
            <button className="network-reload-btn" onClick={handleReload}>
              Reload
            </button>
          </>
        )}
        {/* <button className="network-close-btn" onClick={handleClose}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M15 5L5 15M5 5l10 10"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button> */}
      </div>
    </div>
  );
};

export default NetworkStatusPopup;
